import { Router } from '@angular/router';
/*
 * @Descripttion: 请求拦截
 * @version:
 * @Author: houhailong
 * @Date: 2023-05-20 17:09:51
 * @LastEditors: Aalon
 * @LastEditTime: 2023-05-21 15:55:04
 */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { JwtService } from './jwt.service';
import { environment } from 'src/environments/environment';
import { MessageService } from '@/service/message.service';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly jwtService: JwtService,
    private readonly message: MessageService
  ) {}
  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.jwtService.getToken();
    let secureReq: HttpRequest<any> = req;
    /*
     * 1、地址处理
     * 2、用户信息存储
     */
    secureReq = secureReq.clone({
      url: environment.baseUrl + req.url,
      setHeaders: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return next.handle(secureReq).pipe(
      // deal Error
      catchError((error) => {
        const errorCode = error.status;
        if (errorCode !== 0 && (errorCode < 400 || errorCode >= 600)) {
          //return;
        } else if (500 <= errorCode && errorCode < 600) {
          this.message.error(
            'Oops! Our server is on a break. please try to refresh the page or come back later.'
          );
        } else if (errorCode == 401) {
          this.jwtService.destroyToken();
          //window.location.reload();
        } else if (401 <= errorCode && errorCode < 500) {
          this.message.error(
            'Oops! Are you sending us a bad request? Please check your input and try it again.'
          );
        } else {
          this.message.error(
            'Error Code: ' +
              errorCode +
              '. Oops! Your network might have a problem, please check your network.'
          );
        }
        return throwError(error);
      })
    );
  }
}
